import { useEffect, useRef, useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { ContentCopy } from "@mui/icons-material";
import { toast } from "react-toastify";
import { callPostApi } from "../../function/ApiCallFunction";
import { consoleColors, primaryButtonSx } from "../admin/consoleTheme";

function copyWithInput(input) {
  input.focus();
  input.select();
  input.setSelectionRange(0, input.value.length);
  try {
    return document.execCommand("copy");
  } catch (error) {
    return false;
  }
}

export default function SaleLinkBox({ storeId }) {
  const [url, setUrl] = useState("");
  const [copied, setCopied] = useState(false);
  const linkRef = useRef(null);

  useEffect(() => {
    if (!storeId) return undefined;
    let mounted = true;
    callPostApi("store-draw", { mod: "SALE_LINK", data_arr: { store_id: storeId } }).then((response) => {
      if (!mounted || response.status !== "200" || !response.data?.token) return;
      setUrl(`${window.location.origin}/sale/${response.data.token}`);
    });
    return () => { mounted = false; };
  }, [storeId]);

  const markCopied = () => {
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1600);
    toast.success("Sale link copied");
  };

  const copy = () => {
    const input = linkRef.current;
    if (!input || !url) return;
    if (copyWithInput(input)) {
      markCopied();
      return;
    }
    const selectForManualCopy = () => {
      input.focus();
      input.select();
      toast.info("Link selected. Press Ctrl+C or Cmd+C to copy");
    };
    if (navigator.clipboard?.writeText && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(markCopied).catch(selectForManualCopy);
      return;
    }
    selectForManualCopy();
  };

  if (!url) return null;

  return (
    <Box sx={{ mb: 2, p: 1.6, borderRadius: 3, background: "#fff", border: `1px solid ${consoleColors.line}`, display: "flex", gap: 1.2, alignItems: { xs: "stretch", sm: "center" }, flexDirection: { xs: "column", sm: "row" } }}>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography sx={{ fontSize: 14, fontWeight: 750, color: consoleColors.ink }}>Register sale link</Typography>
        <Typography sx={{ fontSize: 12.5, color: consoleColors.muted, mt: 0.3 }}>Opens the sales calculator on a phone. No login and no menu.</Typography>
        <Box
          component="input"
          ref={linkRef}
          readOnly
          value={url}
          aria-label="Register sale link"
          onFocus={(event) => event.target.select()}
          sx={{ width: "100%", mt: 0.6, border: 0, p: 0, color: consoleColors.accent, fontSize: 12.5, fontFamily: "inherit", background: "transparent", outline: "none" }}
        />
      </Box>
      <Button type="button" variant="contained" onClick={copy} sx={{ ...primaryButtonSx, flexShrink: 0 }} startIcon={<ContentCopy />}>{copied ? "Copied" : "Copy"}</Button>
    </Box>
  );
}
